/**
 * description 图片自适应容器
 * created by zhang.yingyu
 * modified on 2018-12-10
 */
"use strict";
angular.module("imgAdapaModule", [])
    .directive("imgAdapaDir", ["$timeout","$window", function($timeout,$window) {
        return {
            restrict: "AEC",
            repalace: false,
            scope: {
                conWidth:"@",
                conHeight:"@",
            },
            link:function($scope,$elem,attrs){
                $timeout(function(){
                    init();
                },300);
                $scope.status={
                    containerWidth:$scope.conWidth,
                    containerHeight:$scope.conHeight,
                    conRadio:$scope.conWidth/$scope.conHeight,
                    newImgWidth:0,
                    newImgHeight:0,
                }
                function init(){
                    var elemWidth=$elem.width();
                    var elemHeight=$elem.height();
                    var radio=elemWidth/elemHeight;
                    var left,top;
                    if(elemWidth/elemHeight>$scope.status.conRadio){
                        $scope.status.newImgHeight=$scope.status.containerHeight;
                        $scope.status.newImgWidth=$scope.status.containerHeight*radio;
                        top=0;
                        left=-($scope.status.newImgWidth-$scope.status.containerWidth)/2;
                    }else{
                        $scope.status.newImgWidth=$scope.status.containerWidth;
                        $scope.status.newImgHeight=$scope.status.containerWidth/radio;
                        left=0;
                        top=-($scope.status.newImgHeight-$scope.status.containerHeight)/2;
                    };
                    $elem.width($scope.status.newImgWidth);
                    $elem.height($scope.status.newImgHeight);
                    $elem.css('left',left);
                    $elem.css('top',top);
                };

            }
        };
    }]);